export enum PlayersRoutes {
  GetHitterPlayer = 'get-hitter-player',
}
